{{ "Consumption type :" | translate }} <a (click)="openEnergySettingsDialog($event)">{{ consumptionTypeLabel$ | async | translate }}</a>

